<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";

  let { crmContent, fallback } = $props();
</script>

{#if $userStore.hasCrm}
  {@render crmContent?.()}
{:else if fallback}
  {@render fallback?.()}
{/if}
